require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-5-reasons-why-python-is-powerful-enough-for-google.json") })
        }
      }, "path---blog-5-reasons-why-python-is-powerful-enough-for-google");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-5-reasons-why-python-is-powerful-enough-for-google!./.cache/json/blog-5-reasons-why-python-is-powerful-enough-for-google.json
// module id = 561
// module chunks = 231608221292675